export var linkEventAnalytics = {
    uploadNewPrimaryCv: {
        events: ['newcv'],
    },
};
var keysInLinkEvents = Object.keys(linkEventAnalytics);
//# sourceMappingURL=globalAnalytics.js.map